export function BrandIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="6" style={{ fill: "var(--primary)" }} />
      <rect x="1" y="1" width="11" height="6" rx="2" fill="white" opacity="0.12" />
      <rect x="21" y="2" width="9" height="5" rx="1.5" fill="white" opacity="0.08" />
      <rect x="2" y="24" width="8" height="5" rx="1.5" fill="white" opacity="0.08" />
      <rect x="22" y="22" width="8" height="6" rx="2" fill="white" opacity="0.12" />
      <rect x="1" y="13" width="5" height="4" rx="1" fill="white" opacity="0.06" />
      <rect x="26" y="12" width="5" height="4" rx="1" fill="white" opacity="0.06" />
      <text
        x="16"
        y="23.5"
        fontFamily="system-ui, sans-serif"
        fontSize="20"
        fontWeight="700"
        fill="white"
        textAnchor="middle"
      >
        C
      </text>
    </svg>
  );
}
